// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leader-line {
    z-index: 1;
}

.navigation-panning {
    transform: scale(var(--navigation-panning-scale)) !important;
    transform-origin: var(--navigation-panning-x) var(--navigation-panning-y) !important;
    transition: all 0.1s linear !important;
    & * {
        /* override sticky positioning on children */
        --panning-sticky: static !important;
        --panning-visible: hidden !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/navigation/navigation.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,4DAA4D;IAC5D,oFAAoF;IACpF,sCAAsC;IACtC;QACI,4CAA4C;QAC5C,mCAAmC;QACnC,oCAAoC;IACxC;AACJ","sourcesContent":[".leader-line {\n    z-index: 1;\n}\n\n.navigation-panning {\n    transform: scale(var(--navigation-panning-scale)) !important;\n    transform-origin: var(--navigation-panning-x) var(--navigation-panning-y) !important;\n    transition: all 0.1s linear !important;\n    & * {\n        /* override sticky positioning on children */\n        --panning-sticky: static !important;\n        --panning-visible: hidden !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
